import { render, staticRenderFns } from "./NextSteps.vue?vue&type=template&id=466211d4&"
import script from "./NextSteps.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NextSteps.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports